import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { PlacementTypeStepIcon } from '../../components/icons/StepIcons/PlacementTypeStepIcon'
import { PlacementType, placementTypeGermanStrings } from '../../@types/placementType'
import { Progress } from '../../@types/progress'
import { StepTemplate } from '../../components/styled/stepTemplate/StepTemplate'
import { Button } from '../../components/styled/Button/Button'
import { updatePlacementType } from '../../store/lead/leadSlice'
import { ReduxState } from '../../store/reducers'
import { ReportViewEventArgs } from '../../tracking/tracking'
import { useReportViewEvent } from '../../hooks'
import { reportTrackingEvent } from '../../tracking/thunks'

interface PlacementTypeStepProps {
  goToNextStep: () => void
  progress: Progress
}

export const DEFAULT_HEADLINE = 'Worauf möchtest du die Solaranlage installieren?'
export const LEGAL_NOTE_CONTENT = 'Wir finanzieren diesen Service über die Provision unserer Solarpartner'

const PlacementTypeStep: React.FC<PlacementTypeStepProps> = (props) => {
  const { theme, tealium } = useSelector((state: ReduxState) => state.config)

  const reportViewEventArgs: ReportViewEventArgs | undefined = tealium
    ? location.pathname === '/solaranlage/'
      ? { pageTitle: 'realestatetype' }
      : undefined
    : undefined

  useReportViewEvent(reportViewEventArgs)

  const dispatch = useDispatch()

  const goToNextStep = (chosenType: PlacementType) => {
    dispatch(updatePlacementType(chosenType))
    dispatch(
      reportTrackingEvent({
        pageTitle: 'realestatetype',
        label: 'realestatetype_submit',
        inputValue: chosenType,
        eventName: 'lead_input',
        customDimensions: {
          ga_cd_lead_engine_input_value: chosenType,
        },
        category: 'residential',
        action: 'solar-leadengine',
        flow: 'sle',
      })
    )
    props.goToNextStep()
  }

  return (
    <StepTemplate
      headline={DEFAULT_HEADLINE}
      progress={props.progress}
      icon={<PlacementTypeStepIcon />}
      displayNext={false}
      legalNoteContent={LEGAL_NOTE_CONTENT}
    >
      {Object.entries(placementTypeGermanStrings).map(([key, stringValue]) => {
        const placementType = key as PlacementType
        return (
          <Button
            key={placementType}
            onClick={() => goToNextStep(placementType)}
            className='margin-right-l margin-bottom-xl'
            text={stringValue}
            backgroundColor={theme.background}
            color={theme.text}
            borderColor={theme.secondary}
            fontWeight='bold'
          />
        )
      })}
    </StepTemplate>
  )
}

export default PlacementTypeStep
